'use client';

import { BrokerCompanyCardsContainer } from './styled';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { Typography } from '@mui/material';
import { COLORS } from '@/constants';
import { Wrapper, Head } from '@/features/pages/home';
import { Carousel } from '@/features/pages/home/components/Featured/Carousel';
import { IHousingObjectResponse } from '@/types';

type BrokerCompanyCardsProps = {
  objects: IHousingObjectResponse[];
  officeName?: string;
  isProject?: boolean;
};

export const BrokerCompanyCards: FC<BrokerCompanyCardsProps> = ({
  objects,
  officeName,
  isProject,
}) => {
  const t = useTranslations();

  return (
    <Wrapper $bgColor={'beige-parch'}>
      <BrokerCompanyCardsContainer>
        <Head>
          <Typography
            fontSize={30}
            lineHeight={1}
            fontWeight={700}
            color={COLORS['primary/900']}
            zIndex={5}
            sx={{ paddingRight: { xs: 0, sm: '120px' } }}
          >
            {`${t(isProject ? 'housingCardDetails.brokerCompanyCards.titleProject' : 'housingCardDetails.brokerCompanyCards.title')} ${officeName}`}
          </Typography>
        </Head>
        <Carousel data={objects} isProject={isProject} />
      </BrokerCompanyCardsContainer>
    </Wrapper>
  );
};
